// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Gu1Of","secondary":"Button_secondary__g_QV3","arrow":"Button_arrow__M8EbW"};